import {onBannerHeightChange} from 'app/common/header/bannerHeight';

const NS = 'Resizable'; // jshint ignore:line

export default function Resizable($window, unregister, appConstants) {
  "ngInject";

  return {
    require: '?ngModel',
    link: function (scope) {

      // COR-100: the deprecation banner sits above the header, so every
      // "windowHeight - headerHeight" template needs its height included
      const setHeaderHeights = () => {
        scope.headerHeight = appConstants.Dimensions.headerHeight + appConstants.Dimensions.bannerHeight;
        scope.bookingsListNegHeight = appConstants.Dimensions.bookingsListNegHeight + appConstants.Dimensions.bannerHeight;
      };
      setHeaderHeights();

      scope.windowWidth = $window.innerWidth;
      scope.windowHeight = $window.innerHeight;
      scope.resizeStyle = {
        height: $window.innerHeight + 'px'
      };

      scope.getWindowDimensions = function () {
        // can't use window.innerHeight/innerWidth because scale/zoom breaks it
        const docHeight = document.documentElement.clientHeight;
        const docWidth = document.documentElement.clientWidth;
        return {
          h: docHeight,
          w: docWidth
        };
      };

      scope.$watch(scope.getWindowDimensions, function (newValue) {
        scope.windowWidth = newValue.w;
        scope.windowHeight = newValue.h;
        scope.resizeStyle = {
          height: newValue.h + 'px'
        };
      }, true);

      function resize() {
        scope.$apply();
      }

      // CLI-569: the banner can wrap or unwrap after this has rendered
      function bannerHeightChange() {
        setHeaderHeights();
        scope.$applyAsync();
      }

      //-- listen
      const listeners = [];
      const stopBannerListener = onBannerHeightChange(bannerHeightChange);
      $window.addEventListener('resize', resize);
      listeners.push(scope.$on('$destroy', () => {
        unregister(listeners);
        stopBannerListener();
        $window.removeEventListener('resize', resize);
      }));

    }
  };
}
